import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-illegal-dumps',
  templateUrl: './illegal-dumps.component.html',
  styleUrls: ['./illegal-dumps.component.css']
})

export class IllegalDumpsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/dev-man/Kgwetlwo-app/src/app/pages/services/illegal-dumps/illegal-dumps.component.ts